
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X } from 'lucide-react';

interface PortfolioDetailProps {
  item: {
    id: number;
    title: string;
    category: string;
    client: string;
    description: string;
    media: {
      type: 'image' | 'video';
      url: string;
      thumbnail?: string;
      path?: string;
    };
  };
  open: boolean;
  onClose: () => void;
}

const PortfolioDetail: React.FC<PortfolioDetailProps> = ({ item, open, onClose }) => {
  if (!open) return null;
  
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl w-[90%] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <div className="flex items-center justify-between">
            <DialogTitle className="text-xl font-bold">{item.title}</DialogTitle>
            <Button variant="ghost" size="icon" onClick={onClose} className="rounded-full">
              <X size={20} />
            </Button>
          </div>
          <DialogDescription className="text-sm text-muted-foreground">
            Kund: {item.client} · {item.category}
          </DialogDescription>
        </DialogHeader>
        
        <div className="mt-4">
          {item.media.type === 'video' ? (
            <video 
              src={item.media.url} 
              controls 
              controlsList="nodownload" // This prevents the download option
              disablePictureInPicture // This prevents picture-in-picture which can sometimes allow downloads
              className="w-full rounded-md" 
              poster={item.media.thumbnail}
            />
          ) : (
            <img 
              src={item.media.url} 
              alt={item.title} 
              className="w-full rounded-md object-cover"
              onContextMenu={(e) => e.preventDefault()} // This prevents right-click save
            />
          )}
        </div>
        
        <div className="mt-4">
          <p className="text-foreground">{item.description}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PortfolioDetail;
